import { GroupedBarChartDrawer } from './grouped-bar-chart-drawer';
import { Injectable } from '@angular/core';
import { IChartConfig } from './chart-config.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { IChartDrawer } from './chart-drawer.interface';
import { HorizontalBarChartDrawer } from './horizontal-bar-chart-drawer';
import { DonutChartDrawer } from './donut-chart-drawer';
import { SimpleDonutChartWrawer } from './simple-donut-chart-drawer';
import { BarChartDrawer } from './bar-chart-drawer';
import { ChartDrawerType } from './chart-drawer-type.enum';
import { OverflowedHorizontalBarChartDrawer } from './overflowed-horizontal-bar-chart-drawer';

@Injectable()
export class ChartDrawerFactory {
  constructor(private readonly domSanitizer: DomSanitizer) {}

  public get(chartConfig: IChartConfig): IChartDrawer {
    switch (chartConfig.chartDrawerType) {
      case ChartDrawerType.DonutChart:
        return new DonutChartDrawer(chartConfig, this.domSanitizer);
      case ChartDrawerType.BarChart:
        return new BarChartDrawer(chartConfig, this.domSanitizer);
      case ChartDrawerType.HorizontalBarChart:
        return new HorizontalBarChartDrawer(chartConfig, this.domSanitizer);
      case ChartDrawerType.GroupedBarChart:
        return new GroupedBarChartDrawer(chartConfig, this.domSanitizer);
      case ChartDrawerType.OverflowedHorizontalBarChart:
        return new OverflowedHorizontalBarChartDrawer(chartConfig, this.domSanitizer);
      case ChartDrawerType.SimpleDonutChart:
        return new SimpleDonutChartWrawer(chartConfig, this.domSanitizer);
      default:
        throw new Error(`Not supported ChartDrawerType: ${chartConfig.chartDrawerType}`);
    }
  }
}
